<template>
  <div class="root-box">
    <div class="condition-box">
      <el-form class="filter-row" size="small" inline>
        <el-form-item label="统计时间">
          <el-radio-group v-model="quick" @change="applyQuick">
            <el-radio-button :label="6">最近半年</el-radio-button>
            <el-radio-button :label="12">近1年</el-radio-button>
            <el-radio-button :label="24">近2年</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker class="date-picker" v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
            unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false"
            @change="onDateChange" />
        </el-form-item>
        <el-form-item label="汇总">
          <el-radio-group v-model="grain" @change="onGrainChange">
            <el-radio-button label="day">按日</el-radio-button>
            <el-radio-button label="week">按周</el-radio-button>
            <el-radio-button label="month">按月</el-radio-button>
            <el-radio-button label="year">按年</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
        </el-form-item>
      </el-form>
      <el-form class="filter-row" size="small" inline>
        <el-form-item>
          <el-radio-group v-model="view" @change="onViewChange">
            <el-radio-button v-for="item in viewOpts" :key="item.value" :label="item.value">{{
              item.label
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="groupKey" @change="onGroupChange">
            <el-radio-button v-for="item in groups" :key="item.key" :label="item.key">{{
              item.name
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="路线">
          <el-select v-model="pathId" style="width: 160px" placeholder="全部路线" @change="query">
            <el-option v-for="item in pathOpts" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="司机">
          <el-select v-model="driverIds" style="width: 280px" multiple clearable collapse-tags placeholder="全部司机"
            @change="onDriverChange">
            <el-option v-for="item in driverOptions" :key="item.id" :label="`${item.no} - ${item.name}`"
              :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="乘客">
          <el-select v-model="pickPosition" style="width: 140px" @change="query">
            <el-option v-for="item in pickPositionOpts" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="driverIds.length > 1" label="对比指标">
          <el-select v-model="metric" style="width: 160px" placeholder="请选择指标" @change="query">
            <el-option v-for="item in currentGroup.metrics" :key="item.key" :label="item.name" :value="item.key" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="content" :class="{ 'with-pie': pieRow }">
      <div class="chart-main">
        <chart ref="chart" :option="option" :height="560" />
      </div>
      <div v-show="pieRow" class="pie-box">
        <chart ref="pieChart" :option="pieOption" :height="420" />
        <div class="pie-tip">{{ pieHint }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getDriverList, getServiceDuration, getServiceOnTime } from "@/api";
import { DateUtil } from "@/util";

function rangeMonthsEndingYesterday(monthCount) {
  const end = new Date();
  end.setDate(end.getDate() - 1);
  const start = new Date(end.getFullYear(), end.getMonth() - (monthCount - 1), 1);
  return [DateUtil.format(start, "yyyy-MM-dd"), DateUtil.format(end, "yyyy-MM-dd")];
}

const ontimeGroups = [
  {
    key: "paxWindow",
    name: "乘客上车窗口",
    unit: "%",
    totalKey: "paxTotal",
    chart: "stack",
    pie: true,
    yMin: 0,
    yMax: 100,
    metrics: [
      { key: "paxInRate", name: "窗口内", color: "#67C23A" },
      { key: "paxEarlyRate", name: "提前", color: "#409EFF" },
      { key: "paxLateRate", name: "推迟", color: "#F56C6C" }
    ]
  },
  {
    key: "driverPick",
    name: "司机接人准点",
    unit: "%",
    totalKey: "pickTotal",
    chart: "cumulative",
    pie: true,
    yMin: 0,
    yMax: 100,
    metrics: [
      { key: "ontime5Rate", name: "5分钟准点", color: "#67C23A" },
      { key: "ontime10Rate", name: "10分钟准点", color: "#E6A23C" },
      { key: "ontime15Rate", name: "15分钟准点", color: "#F56C6C" }
    ]
  },
  {
    key: "pickLate",
    name: "接人晚到分布",
    unit: "%",
    totalKey: "pickTotal",
    chart: "stack",
    pie: true,
    yMin: 0,
    yMax: 100,
    metrics: [
      { key: "earlyRate", name: "提前", color: "#67C23A" },
      { key: "late0to5Rate", name: "晚0-5分钟", color: "#B3E19D" },
      { key: "late5to10Rate", name: "晚5-10分钟", color: "#E6A23C" },
      { key: "late10to15Rate", name: "晚10-15分钟", color: "#F5A572" },
      { key: "late15Rate", name: "晚15分钟以上", color: "#F56C6C" }
    ]
  },
  {
    key: "send",
    name: "司机送达准点",
    unit: "%",
    totalKey: "sendTotal",
    chart: "cumulative",
    pie: true,
    yMin: 0,
    yMax: 100,
    metrics: [
      { key: "send5Rate", name: "5分钟准点", color: "#67C23A" },
      { key: "send10Rate", name: "10分钟准点", color: "#E6A23C" },
      { key: "send15Rate", name: "15分钟准点", color: "#F56C6C" }
    ]
  }
];

const durationGroups = [
  {
    key: "level",
    name: "时长水平",
    unit: "分钟",
    totalKey: "durationTotal",
    chart: "groupLine",
    yMin: 0,
    metrics: [
      { key: "avgActDuration", name: "实际全程", color: "#409EFF" },
      { key: "avgPlanDuration", name: "规划全程", color: "#67C23A" },
      { key: "avgNavDuration", name: "直达导航", color: "#909399" }
    ]
  },
  {
    key: "delay",
    name: "延误构成",
    unit: "分钟",
    totalKey: "durationTotal",
    chart: "mix",
    metrics: [
      { key: "diffPlan", name: "相对规划", color: "#303133", mark: "line" },
      { key: "k1Delay", name: "上高速晚到", color: "#E6A23C" },
      { key: "k2Delay", name: "高速段晚到", color: "#F56C6C" },
      { key: "waitDuration", name: "等待", color: "#909399" }
    ]
  },
  {
    key: "overtime",
    name: "超时占比",
    unit: "%",
    totalKey: "durationTotal",
    chart: "groupLine",
    yMin: 0,
    metrics: [
      { key: "overPlan10Rate", name: "超规划10分钟", color: "#E6A23C" },
      { key: "overPlan20Rate", name: "超规划20分钟", color: "#F56C6C" },
      { key: "overNav30Rate", name: "超直达30分钟", color: "#409EFF" }
    ]
  }
];

const bandMetrics = [
  { key: "within5", name: "5分钟内", color: "#67C23A" },
  { key: "late5to10", name: "晚5-10分钟", color: "#E6A23C" },
  { key: "late10to15", name: "晚10-15分钟", color: "#F5A572" },
  { key: "over15", name: "超过15分钟", color: "#F56C6C" }
];

export default {
  computed: {
    ...mapState({
      pathOpts: (state) => [{ name: "全部路线", id: "" }, ...(state.pathList || [])]
    }),
    groups() {
      return this.view === "ontime" ? ontimeGroups : durationGroups;
    },
    currentGroup() {
      return this.groups.find((item) => item.key === this.groupKey) || this.groups[0];
    },
    pieHint() {
      return this.rows.length > 36 ? "点击面积图上的点，查看该周期的分布" : "点击柱子，查看该周期的分布";
    }
  },
  data() {
    return {
      view: "ontime",
      viewOpts: [
        { label: "准点率", value: "ontime" },
        { label: "路程时长", value: "duration" }
      ],
      groupKey: "paxWindow",
      quick: 6,
      grain: "month",
      dateRange: rangeMonthsEndingYesterday(6),
      pathId: "",
      driverIds: [],
      driverOptions: [],
      pickPosition: "all",
      pickPositionOpts: [
        { label: "全部乘客", value: "all" },
        { label: "首个上车", value: "first" },
        { label: "后续乘客", value: "later" }
      ],
      metric: "paxInRate",
      rows: [],
      displayRows: [],
      pieRow: null,
      pieOption: {
        tooltip: { trigger: "item" },
        series: []
      },
      option: {
        legend: { show: true, bottom: 0, type: "scroll" },
        grid: { left: 60, right: 30, bottom: 80 },
        xAxis: { type: "category" },
        yAxis: {},
        tooltip: { show: true, trigger: "axis" }
      }
    };
  },
  mounted() {
    this.getNormalDriver();
    this.query();
    this.$nextTick(() => {
      const chart = this.$refs.chart && this.$refs.chart.chart;
      if (!chart) {
        return;
      }
      chart.on("click", (params) => {
        const date = (params && (params.name || (params.data && params.data.date))) || "";
        if (!date || !this.currentGroup.pie || this.driverIds.length > 1) {
          return;
        }
        const row = this.displayRows.find((item) => item.date === date);
        if (!row) {
          return;
        }
        this.pieRow = row;
        this.renderPie();
      });
    });
  },
  methods: {
    getNormalDriver() {
      getDriverList({
        param: { status: 1 },
        page: { current: 1, size: 100 }
      }).then((res) => {
        const { records = [] } = res.data || {};
        records.sort((a, b) => a.no - b.no);
        this.driverOptions = records;
        if (this.driverIds.length > 1 && this.rows.length) {
          this.renderChart();
        }
      });
    },
    onViewChange() {
      const group = this.groups[0];
      this.groupKey = group.key;
      this.metric = group.metrics[0].key;
      this.query();
    },
    onGroupChange() {
      const metric = this.currentGroup.metrics[0].key;
      this.metric = metric;
      if (this.driverIds.length > 1) {
        this.query();
        return;
      }
      this.renderChart();
    },
    onDriverChange() {
      const keys = this.currentGroup.metrics.map((item) => item.key);
      if (this.driverIds.length > 1 && !keys.includes(this.metric)) {
        this.metric = keys[0];
      }
      this.query();
    },
    applyQuick(monthCount) {
      if (!monthCount) {
        return;
      }
      this.dateRange = rangeMonthsEndingYesterday(monthCount);
      this.query();
    },
    onDateChange() {
      this.quick = "";
      this.query();
    },
    onGrainChange(grain) {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.query();
        return;
      }
      const end = new Date(this.dateRange[1].replace(/-/g, "/"));
      let start;
      if (grain === "year") {
        start = new Date(end.getFullYear() - 2, 0, 1);
      } else if (grain === "month") {
        start = new Date(end.getFullYear(), end.getMonth() - 11, 1);
      } else if (grain === "week") {
        start = new Date(end);
        start.setDate(start.getDate() - 83);
      } else {
        this.query();
        return;
      }
      this.quick = "";
      this.dateRange = [DateUtil.format(start, "yyyy-MM-dd"), DateUtil.format(end, "yyyy-MM-dd")];
      this.query();
    },
    query() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning("请选择统计时间");
        return;
      }
      const param = {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        grain: this.grain,
        pathId: this.pathId,
        driverIds: this.driverIds,
        pickPosition: this.pickPosition,
        metric: this.driverIds.length > 1 ? this.metric : null
      };
      const request = this.view === "ontime" ? getServiceOnTime : getServiceDuration;
      request(param).then((res) => {
        this.rows = res.data || [];
        this.renderChart();
      });
    },
    renderChart() {
      if (this.driverIds.length > 1) {
        this.pieRow = null;
        this.renderCompareChart();
        return;
      }
      this.renderGroupChart();
    },
    num(value) {
      if (value == null || value === "") {
        return null;
      }
      const n = Number(value);
      return Number.isNaN(n) ? null : n;
    },
    round2(value) {
      return Math.round(value * 100) / 100;
    },
    viewModel(group, rows) {
      if (group.chart !== "cumulative") {
        return { rows, metrics: group.metrics };
      }
      const [m5, m10, m15] = group.metrics;
      const nextRows = rows.map((row) => {
        const a = this.num(row[m5.key]);
        const b = this.num(row[m10.key]);
        const c = this.num(row[m15.key]);
        return {
          ...row,
          within5: a == null ? null : this.round2(a),
          late5to10: a == null || b == null ? null : this.round2(Math.max(b - a, 0)),
          late10to15: b == null || c == null ? null : this.round2(Math.max(c - b, 0)),
          over15: c == null ? null : this.round2(Math.max(100 - c, 0))
        };
      });
      return { rows: nextRows, metrics: bandMetrics };
    },
    renderGroupChart() {
      const group = this.currentGroup;
      const model = this.viewModel(group, this.rows);
      const dense = model.rows.length > 36;
      const stacked = group.chart === "stack" || group.chart === "cumulative";
      const data = stacked && !dense ? this.withStackTrend(model.metrics, model.rows) : model.rows;
      this.displayRows = data;
      const nameToKey = {};
      const dimensions = ["date"];
      const series = [];
      model.metrics.forEach((item, index) => {
        nameToKey[item.name] = item.key;
        dimensions.push(item.key);
        series.push(this.buildSeries(item, group, data.length, dense, stacked));
        const lastStack = stacked && index === model.metrics.length - 1;
        if (!dense && !lastStack && (group.chart === "groupLine" || stacked)) {
          const yKey = stacked ? `${item.key}Trend` : item.key;
          if (stacked) {
            dimensions.push(yKey);
          }
          series.push(this.buildTrendLine(item, yKey));
        }
      });
      const option = this.buildOption(data, dimensions, series, nameToKey, group);
      this.$refs.chart.setOption(option, true);
      this.showDistributionPie(model.metrics);
    },
    buildSeries(item, group, count, dense, stacked) {
      const encode = { x: "date", y: item.key };
      const color = item.color;
      const cursor = group.pie ? "pointer" : "default";
      if (item.mark === "line") {
        return {
          type: "line",
          smooth: true,
          name: item.name,
          encode,
          z: 5,
          symbol: "circle",
          symbolSize: 8,
          itemStyle: { color },
          lineStyle: { width: 2, color }
        };
      }
      if (stacked) {
        if (dense) {
          return {
            type: "line",
            smooth: true,
            name: item.name,
            encode,
            stack: "dist",
            symbol: "circle",
            symbolSize: 6,
            triggerLineEvent: true,
            cursor,
            itemStyle: { color },
            lineStyle: { width: 1, color },
            areaStyle: { opacity: 0.45, color },
            emphasis: { focus: "series" }
          };
        }
        return {
          type: "bar",
          name: item.name,
          encode,
          stack: "dist",
          barMaxWidth: 48,
          cursor,
          itemStyle: { color },
          emphasis: { focus: "series" }
        };
      }
      if (dense) {
        return {
          type: "line",
          smooth: true,
          name: item.name,
          encode,
          symbol: "circle",
          symbolSize: 6,
          itemStyle: { color },
          lineStyle: { width: 2, color }
        };
      }
      const showLabel = count <= 8 && group.metrics.length <= 3;
      return {
        type: "bar",
        name: item.name,
        encode,
        barMaxWidth: 18,
        barGap: "20%",
        itemStyle: { color },
        emphasis: { focus: "series" },
        label: {
          show: showLabel,
          position: "top",
          fontSize: 11,
          color: "#606266",
          formatter: (params) => {
            const row = params.data || {};
            const value = row[item.key];
            return value == null ? "" : `${value}`;
          }
        }
      };
    },
    withStackTrend(metrics, rows) {
      return rows.map((row) => {
        const next = { ...row };
        let sum = 0;
        let any = false;
        metrics.forEach((item) => {
          const value = this.num(row[item.key]);
          if (value != null) {
            sum += value;
            any = true;
          }
          next[`${item.key}Trend`] = any ? this.round2(sum) : null;
        });
        return next;
      });
    },
    buildTrendLine(item, yKey) {
      const key = yKey || item.key;
      return {
        id: `${item.key}-trend`,
        type: "line",
        name: item.name,
        encode: { x: "date", y: key },
        z: 5,
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        itemStyle: item.color ? { color: item.color } : undefined,
        lineStyle: { width: 2, color: item.color || undefined }
      };
    },
    showDistributionPie(metrics) {
      const group = this.currentGroup;
      if (!group.pie || !this.displayRows.length) {
        this.pieRow = null;
        return;
      }
      const kept = this.pieRow && this.displayRows.find((item) => item.date === this.pieRow.date);
      this.pieRow = kept || this.displayRows[this.displayRows.length - 1];
      this.$nextTick(() => this.renderPie(metrics));
    },
    renderPie(metrics) {
      const row = this.pieRow;
      const group = this.currentGroup;
      const pie = this.$refs.pieChart;
      const slices = metrics || (group.chart === "cumulative" ? bandMetrics : group.metrics);
      if (!row || !group.pie || !pie) {
        return;
      }
      const total = group.totalKey ? row[group.totalKey] : null;
      pie.setOption(
        {
          title: {
            text: row.date,
            subtext: total == null ? "" : `订单数 ${total}`,
            left: "center",
            top: 8,
            textStyle: { fontSize: 16, fontWeight: "normal" }
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}：{c}%"
          },
          legend: { bottom: 0, type: "scroll" },
          series: [
            {
              type: "pie",
              radius: ["38%", "62%"],
              center: ["50%", "54%"],
              data: slices.map((item) => ({
                name: item.name,
                value: row[item.key] == null ? 0 : Number(row[item.key]),
                itemStyle: { color: item.color }
              }))
            }
          ]
        },
        true
      );
    },
    renderCompareChart() {
      const group = this.currentGroup;
      const metric = group.metrics.find((item) => item.key === this.metric) || group.metrics[0];
      const driverMap = {};
      this.driverOptions.forEach((item) => {
        driverMap[item.id] = item;
      });
      const dense = this.rows.length > 36;
      const dimensions = ["date"];
      const series = [];
      const nameToKey = {};
      this.displayRows = [];
      const compareColors = ["#409EFF", "#67C23A", "#E6A23C", "#F56C6C", "#909399", "#9B59B6", "#1ABC9C", "#E67E22"];
      this.driverIds.forEach((id, index) => {
        const driver = driverMap[id];
        const key = `${id}`;
        const name = driver ? `${driver.no} - ${driver.name}` : key;
        const color = compareColors[index % compareColors.length];
        nameToKey[name] = key;
        dimensions.push(key);
        series.push({
          type: dense ? "line" : "bar",
          smooth: true,
          barMaxWidth: 18,
          name,
          encode: { x: "date", y: key },
          itemStyle: { color },
          label: {
            show: !dense && this.rows.length <= 8,
            position: "top",
            fontSize: 11,
            color: "#606266"
          }
        });
      });
      if (!dense) {
        this.driverIds.forEach((id, index) => {
          const driver = driverMap[id];
          const key = `${id}`;
          const name = driver ? `${driver.no} - ${driver.name}` : key;
          series.push(this.buildTrendLine({
            key,
            name,
            color: compareColors[index % compareColors.length]
          }));
        });
      }
      const option = this.buildOption(this.rows, dimensions, series, nameToKey, {
        unit: group.unit,
        totalKey: null,
        name: metric.name,
        yMin: group.unit === "%" || group.chart === "groupLine" ? 0 : null,
        yScale: group.unit !== "%" && group.chart !== "groupLine"
      });
      option.title = { text: metric.name, left: 0, textStyle: { fontSize: 14, fontWeight: "normal" } };
      this.$refs.chart.setOption(option, true);
    },
    buildOption(data, dimensions, series, nameToKey, group) {
      const unit = group.unit === "%" ? "%" : "";
      const hasBar = series.some((item) => item.type === "bar");
      const legendData = [];
      series.forEach((item) => {
        if (item.id && String(item.id).endsWith("-trend")) {
          return;
        }
        if (!legendData.includes(item.name)) {
          legendData.push(item.name);
        }
      });
      return {
        title: { text: "" },
        legend: { show: true, bottom: 0, type: "scroll", data: legendData },
        grid: { left: 60, right: 24, top: 36, bottom: this.grain === "week" ? 100 : 80 },
        xAxis: {
          type: "category",
          axisLabel: { rotate: this.grain === "week" ? 30 : 0 }
        },
        yAxis: {
          type: "value",
          name: group.unit,
          min: group.yMin == null ? undefined : group.yMin,
          max: group.yMax == null ? undefined : group.yMax,
          scale: !!group.yScale,
          nameTextStyle: { color: "#909399" }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: { type: hasBar ? "shadow" : "line" },
          formatter: (params) => {
            const list = Array.isArray(params) ? params : [params];
            const row = (list[0] && list[0].data) || {};
            const total = group.totalKey ? row[group.totalKey] : null;
            let text = list[0].axisValue || "";
            if (total != null) {
              text += `（订单数 ${total}）`;
            }
            list.forEach((item) => {
              if (item.seriesId && String(item.seriesId).endsWith("-trend")) {
                return;
              }
              const key = nameToKey[item.seriesName];
              const value = key ? row[key] : null;
              const shown = value == null ? "-" : `${value}${unit}`;
              text += `<br/>${item.marker}${item.seriesName}：${shown}`;
            });
            if (group.chart === "cumulative") {
              group.metrics.forEach((item) => {
                const value = row[item.key];
                const shown = value == null ? "-" : `${value}%`;
                text += `<br/>${item.name}：${shown}`;
              });
            }
            return text;
          }
        },
        series,
        dataset: { dimensions, source: data }
      };
    }
  }
};
</script>

<style lang="less" scoped>
.root-box {
  min-width: 1000px;

  .filter-row+.filter-row {
    margin-top: 4px;
  }

  .date-picker {
    width: 340px;
  }

  .content {
    display: flex;
    align-items: flex-start;
    margin-top: 12px;
    width: 100%;
  }

  .chart-main {
    flex: 1;
    min-width: 0;
  }

  .pie-box {
    width: 420px;
    flex-shrink: 0;
  }

  .pie-tip {
    color: #909399;
    font-size: 12px;
    text-align: center;
  }
}
</style>
